import React from 'react';

import DeliverySVG from "../../common/svgs/DeliverySVG"
import PickUpSVG from "../../common/svgs/PickUpSVG";
import CurbsideSVG from "../../common/svgs/CurbsideSVG";
import InStoreSvg from "../../common/svgs/InStoreSVG";
import PromotionSVG from '../../common/svgs/PromotionSVG';
import RefundSVG from '../../common/svgs/RefundSVG';
import PhoneSVG from '../../common/svgs/PhoneSVG';
import EmailSVG from '../../common/svgs/EmailSVG';

const TimeLineIcon = props => {

    const { roundBorder, promotionColor, refundColor, deliveryColor, pickUpColor, curbsideColor, inStoreColor,
         notificationEmailColor, notificationSMSColor } = styles

    switch (props.item.type) {
        case 'ORDER': {

            switch (props.item.message) {
                case 'Delivery': {
                    return (
                        <div style={{ ...roundBorder, ...deliveryColor }}>
                            <DeliverySVG width={25} height={25} fill={deliveryColor.borderColor} />
                        </div>
                    );
                }
                case 'Collection': {
                    return (
                        <div style={{ ...roundBorder, ...pickUpColor }}>
                            <PickUpSVG width={25} height={25} fill={pickUpColor.borderColor} />
                        </div>
                    );
                }
                case 'Curbside': {
                    return (
                        <div style={{ ...roundBorder, ...curbsideColor }}>
                            <CurbsideSVG width={25} height={25} fill={curbsideColor.borderColor} />
                        </div>
                    );
                }
                case 'Dine In': {
                    return (
                        <div style={{ ...roundBorder, ...inStoreColor }}>
                            <InStoreSvg width={25} height={25} fill={inStoreColor.borderColor} />
                        </div>
                    );
                }
            }

        }
        case 'REFUND': {
            return (
                <div style={{ ...roundBorder, ...refundColor }}>
                    <RefundSVG width={35} height={35} fill={promotionColor.borderColor} />
                </div>
            );
        }
        case 'PROMOTION': {
            return (
                <div style={{ ...roundBorder, ...promotionColor }}>
                    <PromotionSVG width={25} height={25} fill={promotionColor.borderColor} />
                </div>
            );
        }
        case 'NOTIFICATION_EMAIL': {
            return (
                <div style={{ ...roundBorder, ...notificationEmailColor }}>
                    <EmailSVG width={25} height={25} fill={notificationEmailColor.borderColor} />
                </div>
            );
        }
        case 'NOTIFICATION_SMS': {
            return (
                <div style={{ ...roundBorder, ...notificationSMSColor }}>
                    <PhoneSVG width={25} height={25} fill={notificationSMSColor.borderColor} />
                </div>
            );
        }
        default: {
            return null;
        }
    }
}

export default TimeLineIcon;

const styles = {
    roundBorder: {
        border: '2px solid black',
        borderRadius: '90%',
        width: '50px',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'white'
    },
    promotionColor: {
        borderColor: 'rgb(237,105,157)'
    },
    pickUpColor: {
        borderColor: 'rgb(82,234,208)'
    },
    deliveryColor: {
        borderColor: 'rgb(50,156,221)'
    },
    curbsideColor: {
        borderColor: 'rgb(206,30,178)'
    },
    inStoreColor: {
        borderColor: 'rgb(81,207,247)'
    },
    refundColor: {
        borderColor: 'rgb(227,166,235)'
    },
    notificationSMSColor: {
        borderColor: 'rgb(247,228,114)'
    },
    notificationEmailColor: {
        borderColor: 'rgb(241,183,106)'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/TimeLineIcon.js